var $toggleAccordion;

$(document).ready(function($) {
    $toggleAccordion    = $('.js-toggle-accordion');

    $toggleAccordion.on('click', function(e) {
        e.stopPropagation();
        let $parent = $(this).parent();

        if ($parent.hasClass('is-open')) {
            $parent.removeClass('is-open');

            if(typeof LayerSystem !== "undefined") {
                $(this).next().stop().slideUp({
                    complete: LayerSystem.update()
                });
            } else {
                $(this).next().stop().slideUp();
            }

        } else {
            $toggleAccordion.parent().removeClass('is-open');
            $toggleAccordion.next().stop().slideUp();

            $parent.addClass('is-open');

            if(typeof LayerSystem !== "undefined") {
                $(this).next().stop().slideDown({
                    complete: LayerSystem.update()
                });
            } else {
                $(this).next().stop().slideDown();
            }
        }
    });
});
